import { createAsyncThunk, createSlice, current } from "@reduxjs/toolkit";
import axiosInstance from "../../../services/API";

export const createNeiborhoodNews = createAsyncThunk("createNeiborhoodNews", async ({ formData }, { rejectWithValue }) => {
    try {
        const response = await axiosInstance.post(`/neighbor_news/create-news/`, formData,
            { headers: { 'Content-Type': 'multipart/form-data' } })
        const result = response.data;
        return result

    } catch (error) {
        if (error.response) {
            return rejectWithValue(error.response.data);
        } else if (error.request) {
            return rejectWithValue("No response from server");
        } else {
            return rejectWithValue(error.message);
        }
    }
});

export const updateNeiborhoodNews = createAsyncThunk("updateNeiborhoodNews", async ({ newsId, formData }, { rejectWithValue }) => {
    try {
        const response = await axiosInstance.patch(`/neighbor_news/update-news/${newsId}/`, formData,
            { headers: { 'Content-Type': 'multipart/form-data' } })
        const result = response.data;
        return result

    } catch (error) {
        if (error.response) {
            return rejectWithValue(error.response.data);
        } else if (error.request) {
            return rejectWithValue("No response from server");
        } else {
            return rejectWithValue(error.message);
        }
    }
});

export const getNeighborhoodNews = createAsyncThunk("getNeighborhoodNews", async ({ page }, { rejectWithValue }) => {
    try {
        const response = await axiosInstance.get(`/neighbor_news/get_nearby_neighborhoodnews/?page=${page}`)
        const result = response.data;
        return result

    } catch (error) {
        if (error.response) {
            return rejectWithValue(error.response.data);
        }
        else if (error.request) {
            return rejectWithValue("No response from server");
        }
        else {
            return rejectWithValue(error.message);
        }
    }
});

export const neighborhoodNewsFilter = createAsyncThunk("neighborhoodNewsFilter", async ({ selectedFilter, page }, { rejectWithValue }) => {
    try {
        const response = await axiosInstance.get(`/neighbor_news/news/filter/?time_filter=${selectedFilter}&page=${page}`)
        const result = response.data;
        return result
    } catch (error) {
        if (error.response) {
            return rejectWithValue(error.response.data);
        }
        else if (error.request) {
            return rejectWithValue("No response from server");
        }
        else {
            return rejectWithValue(error.message);
        }
    }
});

export const getLoginUserNeighborhoodNews = createAsyncThunk("getLoginUserNeighborhoodNews",
    async ({ nextUrl, isLoadMore = false }) => {
        try {
            let response;
            if (nextUrl) {
                const url = new URL(nextUrl);
                const pathAndQuery = url.pathname + url.search;
                const relativePath = pathAndQuery.replace('/api', '');
                response = await axiosInstance.get(relativePath);
            } else {
                response = await axiosInstance.get(`/neighbor_news/getAllNewsOfUser/`);
            }
            return { data: response.data, isLoadMore };
        } catch (error) {
            throw error;
        }
    }
);

export const getSingleNeighborhoodNews = createAsyncThunk("getSingleNeighborhoodNews", async ({ id }, { rejectWithValue }) => {
    try {
        const response = await axiosInstance.get(`/neighbor_news/get-news/${id}/`)
        const result = response.data;
        return result
    } catch (error) {
        if (error.response) {
            return rejectWithValue(error.response.data);
        }
        else if (error.request) {
            return rejectWithValue("No response from server");
        }
        else {
            return rejectWithValue(error.message);
        }
    }
});

export const deleteNeighborhoodNews = createAsyncThunk("deleteNeighborhoodNews", async ({ id }, { rejectWithValue }) => {
    try {
        const response = await axiosInstance.delete(`/neighbor_news/delete-news/${id}/`)
        const result = response.data;
        return result
    } catch (error) {
        if (error.response) {
            return rejectWithValue(error.response.data);
        }
        else if (error.request) {
            return rejectWithValue("No response from server");
        }
        else {
            return rejectWithValue(error.message);
        }
    }
});

export const likeNeighborhoodNews = createAsyncThunk("likeNeighborhoodNews", async ({ id }, { rejectWithValue }) => {
    try {
        const response = await axiosInstance.post(`/neighbor_news/neighborhoodNewsLike/${id}/`)
        const result = response.data;
        return result
    } catch (error) {
        if (error.response) {
            return rejectWithValue(error.response.data);
        }
        else if (error.request) {
            return rejectWithValue("No response from server");
        }
        else {
            return rejectWithValue(error.message);
        }
    }
});

// export const createNeighborhoodNewsComment = createAsyncThunk("createNeighborhoodNewsComment", async ({ id, data }, { rejectWithValue }) => {
//     try {
//         const response = await axiosInstance.post(`/neighbor_news/add-comment/${id}/`, data)
//         const result = response.data;
//         return result
//     } catch (error) {
//         if (error.response) {
//             // The request was made and the server responded with a status code
//             return rejectWithValue(error.response.data);
//         }
//         else if (error.request) {
//             // The request was made but no response was received
//             return rejectWithValue("No response from server");
//         }
//         else {
//             // Something happened in setting up the request that triggered an Error
//             return rejectWithValue(error.message);
//         }
//     }
// });


export const NeighborhoodNewsSlice = createSlice({
    name: "NeighborhoodNews",
    initialState: {
        neighborhoodNews: [],
        next: null,
        previous: null,
        loading: false,
        isLoadMore: false,
        error: null,
    },
    reducers: {
        resetNews: (state) => {
            state.neighborhoodNews = [];
            state.next = null;
            state.previous = null;
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        // Add reducers for additional action types here, and handle loading state as needed
        builder.addCase(createNeiborhoodNews.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(createNeiborhoodNews.fulfilled, (state, action) => {
            state.loading = false;
            state.neighborhoodNews = [action.payload, ...current(state.neighborhoodNews)];
        });
        builder.addCase(createNeiborhoodNews.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
        // Add reducers for additional action types here, and handle loading state as needed
        builder.addCase(updateNeiborhoodNews.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(updateNeiborhoodNews.fulfilled, (state, action) => {
            state.loading = false;
            state.neighborhoodNews = action.payload;
        });
        builder.addCase(updateNeiborhoodNews.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
        // get neighborhood news
        builder.addCase(getNeighborhoodNews.pending, (state, action) => {
            if (action.meta.arg.page === 1) {
                state.neighborhoodNews = [];
            }
            if (action.meta.arg.page > 1) {
                state.isLoadMore = true;
            } else {
                state.loading = true;
            }
        });
        builder.addCase(getNeighborhoodNews.fulfilled, (state, action) => {
            state.loading = false;
            let newNews = (action.payload && action.payload.results) ? action.payload.results : [];
            // Deduplicate by id
            const allNews = [...current(state.neighborhoodNews), ...newNews];
            const uniqueNews = allNews.filter((item, index, self) =>
                index === self.findIndex((t) => t.id === item.id)
            );
            state.neighborhoodNews = uniqueNews;
            state.next = action.payload.next;
            state.isLoadMore = false;
        });
        builder.addCase(getNeighborhoodNews.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
        // get login user created  neighborhood news
        builder.addCase(getLoginUserNeighborhoodNews.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(getLoginUserNeighborhoodNews.fulfilled, (state, action) => {

            const { data, isLoadMore } = action.payload;
            let newNews = data ? data.results : [];
            state.neighborhoodNews = isLoadMore ? [...current(state.neighborhoodNews), ...newNews] : newNews;
            state.loading = false;
        });
        builder.addCase(getLoginUserNeighborhoodNews.rejected, (state, action) => {
            state.error = action.payload;
            state.loading = false;
        });
        // filter neighborhood news
        builder.addCase(neighborhoodNewsFilter.pending, (state, action) => {
            if (action.meta.arg.page === 1) {
                state.neighborhoodNews = [];
            }
            if (action.meta.arg.page > 1) {
                state.isLoadMore = true;
            } else {
                state.loading = true;
            }
        });
        builder.addCase(neighborhoodNewsFilter.fulfilled, (state, action) => {
            state.loading = false;
            state.isLoadMore = false;
            let newNews = (action.payload && action.payload.results) ? action.payload.results : [];
            // Deduplicate by id
            const allNews = [...current(state.neighborhoodNews), ...newNews];
            const uniqueNews = allNews.filter((item, index, self) =>
                index === self.findIndex((t) => t.id === item.id)
            );
            state.neighborhoodNews = uniqueNews;
            state.next = action.payload.next;
            state.previous = action.payload.previous;
        });
        builder.addCase(neighborhoodNewsFilter.rejected, (state, action) => {
            state.loading = false;
            state.isLoadMore = false;
            state.error = action.payload;
        });
        // get single neighborhood news
        builder.addCase(getSingleNeighborhoodNews.pending, (state) => {
            state.loading = true;
            state.neighborhoodNews = {};
        });
        builder.addCase(getSingleNeighborhoodNews.fulfilled, (state, action) => {
            state.loading = false;
            state.neighborhoodNews = action.payload;
        });
        builder.addCase(getSingleNeighborhoodNews.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        builder.addCase(deleteNeighborhoodNews.pending, (state) => {
            state.loading = true;
        }
        );
        builder.addCase(deleteNeighborhoodNews.fulfilled, (state, action) => {
            state.loading = false;
            state.neighborhoodNews = Array.isArray(state.neighborhoodNews)
                ? state.neighborhoodNews.filter(news => news.id !== action.meta.arg.id)
                : state.neighborhoodNews;
            state.next = action.payload.next;
        }
        );
        builder.addCase(deleteNeighborhoodNews.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        // // get single neighborhood news
        // builder.addCase(createNeighborhoodNewsComment.pending, (state) => {
        //     state.loading = true;
        // });
        // builder.addCase(createNeighborhoodNewsComment.fulfilled, (state, action) => {
        //     state.loading = false;
        // });
        // builder.addCase(createNeighborhoodNewsComment.rejected, (state, action) => {
        //     state.loading = false;
        // });
    },
});

export default NeighborhoodNewsSlice.reducer;